<script module>
  export const meta = {
    title: 'Group sessions',
    teaser:
      'Learn how to transform solo sessions into communal activities by sharing links,\nstaying updated with notifications, utilizing voice chat, and celebrating\nprogress together. These steps foster a strong sense of community and shared\ngoals, enhancing motivation.',
    sort: 2,
  }
</script>

<h2>Sharing Is Caring</h2>
<p>
  Once you’ve set up a session, the next step is simple: share the link! Pass it
  along to your friends and colleagues so they can dive into the experience with
  you. It’s an effortless way to transform a solo endeavor into a communal
  activity.
</p>
<h2>Stay in the Loop</h2>
<p>
  For those who love staying connected, make sure your notifications are turned
  on. This way, you’ll receive an alert the moment a new session starts. It’s
  like getting an exclusive invite to every party.
</p>
<h2>Communication Is Key</h2>
<p>
  To make sessions even more interactive, there’s an <strong>optional</strong> voice-only
  chat feature. Perfect for catching up on the latest news or sharing a laugh, this
  feature ensures that everyone can stay in the loop and feel more connected during
  the session.
</p>
<h2>Celebrate Progress Together</h2>
<p>
  One of the best parts about group sessions? The opportunity to see each
  other’s progress once it’s all said and done. It’s a fantastic way to
  celebrate achievements together and perhaps even engage in some friendly
  competition.
</p>
<p>
  Incorporating group sessions into your routine not only spices things up but
  also fosters a sense of community and shared goals. So, why not try it out?
  You might just find that it’s the motivational boost you’ve been looking for.
</p>
